import { useEffect, useState } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/tps/Header";
import { MobileCallBar } from "@/components/tps/MobileCallBar";
import { Hero } from "@/components/tps/Hero";
import { BinSizes } from "@/components/tps/BinSizes";
import { WhatWeTake } from "@/components/tps/WhatWeTake";
import { WhyUs } from "@/components/tps/WhyUs";
import { HowItWorks } from "@/components/tps/HowItWorks";
import { ServiceArea } from "@/components/tps/ServiceArea";
import { QuoteForm } from "@/components/tps/QuoteForm";
import { Footer } from "@/components/tps/Footer";
import { HeroPreview } from "@/components/tps/HeroPreview";
import { BlogPage } from "@/components/tps/BlogPage";
import { AdminPage } from "@/components/tps/AdminPage";

function useRevealOnScroll() {
    useEffect(() => {
        if (typeof window === "undefined") return;
        const els = document.querySelectorAll(".tp-reveal");
        if (!els.length || !("IntersectionObserver" in window)) {
            els.forEach((el) => el.classList.add("is-visible"));
            return;
        }
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("is-visible");
                        io.unobserve(entry.target);
                    }
                });
            },
            { rootMargin: "0px 0px -50px 0px", threshold: 0.08 },
        );
        els.forEach((el) => io.observe(el));
        return () => io.disconnect();
    }, []);
}

function App() {
    useRevealOnScroll();

    // Simple route: /hero-picker shows candidate hero photos for selection.
    const [path, setPath] = useState(
        typeof window !== "undefined" ? window.location.pathname : "/",
    );
    useEffect(() => {
        const onPop = () => setPath(window.location.pathname);
        window.addEventListener("popstate", onPop);
        return () => window.removeEventListener("popstate", onPop);
    }, []);

    if (path === "/hero-picker") {
        return (
            <div className="min-h-screen bg-tp-offwhite text-tp-ink">
                <HeroPreview />
                <Toaster position="top-center" richColors closeButton />
            </div>
        );
    }

    if (path === "/blog" || path === "/blog/") {
        return (
            <>
                <BlogPage />
                <Toaster position="top-center" richColors closeButton />
            </>
        );
    }

    if (path === "/admin" || path === "/admin/") {
        return (
            <>
                <AdminPage page="dashboard" />
                <Toaster position="top-center" richColors closeButton />
            </>
        );
    }

    if (path === "/admin/login" || path === "/admin/login/") {
        return (
            <>
                <AdminPage page="login" />
                <Toaster position="top-center" richColors closeButton />
            </>
        );
    }

    return (
        <div className="min-h-screen bg-tp-offwhite text-tp-ink">
            <Header />
            <main id="main" className="pb-24 md:pb-0">
                <Hero />
                <BinSizes />
                <WhatWeTake />
                <WhyUs />
                <HowItWorks />
                <ServiceArea />
                <QuoteForm />
            </main>
            <Footer />
            <MobileCallBar />
            <Toaster position="top-center" richColors closeButton />
        </div>
    );
}

export default App;
